<template>
  <div>
    <div class="time"><Icon type="ios-time" color="#FF9D00" size="22" />{{ hour }}：{{ minite }}：{{ second }}</div>
  </div>
</template>
<script>
import util from '@/libs/util'
export default {
  props: {
    duration: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      day: 0,
      hour: '00',
      minite: '00',
      second: '00',
      times: 0,
      startTime: 0,
      isEnd: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.isEnd = false
      this.startTime = Date.parse(new Date())
      this.countdown()
    },
    countdown() {
      if (this.isEnd) return false // 交卷后暂停计时
      const now = Date.parse(new Date())
      const end = parseInt(this.startTime + this.duration)
      let times = end - now
      if (times < 0) return false
      this.day = parseInt(times / 1000 / 60 / 60 / 24)
      this.hour = parseInt((times / 1000 / 60 / 60) % 24)
      this.minite = parseInt((times / 1000 / 60) % 60)
      this.second = parseInt((times / 1000) % 60)
      // 个位数前补零
      this.hour = this.hour > 9 ? this.hour : '0' + this.hour
      this.minite = this.minite > 9 ? this.minite : '0' + this.minite
      this.second = this.second > 9 ? this.second : '0' + this.second
      setTimeout(() => {
        this.countdown()
      }, 1000)
    },
    endCount() {
      let h, m, s, hh, mm, ss, spendTime
      this.isEnd = true
      h = this.hour > 9 ? this.hour : this.hour.substr(1)
      m = this.minite > 9 ? this.minite : this.minite.substr(1)
      s = this.second > 9 ? this.second : this.second.substr(1)
      spendTime = this.duration - (h * 60 * 60 + m * 60 + s) * 1000 // 花费时间 = 总时长 - 现在截止的时间(毫秒)
      // spendTime = h + '小时' + m + '分钟' + s + '秒'
      hh = parseInt((spendTime / 1000 / 60 / 60) % 24)
      mm = parseInt((spendTime / 1000 / 60) % 60)
      ss = parseInt((spendTime / 1000) % 60)
      spendTime = (hh > 0 ? hh + '小时' : '') + (mm > 0 ? mm + '分钟' : '0分钟') + (ss > 0 ? ss + '秒' : '')
      this.$emit('childFn', spendTime)
    }
  },
  mounted() {},
  watch: {},
  computed: {}
}
</script>
<style scoped lang="less">
/* .time{
    font-size: 30px;
    font-weight: 600;
} */
.time {
  display: inline-flex;
  align-items: center;
  font-size: 20px;
  color: #ff9d00;
  /deep/ .ivu-icon {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/practise/components/countDown.vue